const Destination = ({text}) =>
    <span className="text-rose-400">{text}</span>

export default Destination
